import React, { Component } from 'react';
import {connect} from 'react-redux';
import { insertSubQuestion, emptyDemoSubQuestionResponse} from '../../actions/demographics';
import AddSubQuestion from '../../components/demographics/addSubQuestion';

class AddDemographicsSubQuestion extends Component {
  constructor(props){
    super(props)

    // this.queryString = window.location.href;

    // if (this.queryString !== "") {
    //   this.catID = this.queryString.split('&c:')[1];  //participant id 
    // }

    this.state={
        editCategoryPageData : "",
       // catID : this.catID
    };
    this.insertSubQuestion = this.insertSubQuestion.bind(this);
    this.emptyDemoSubQuestionResponse = this.emptyDemoSubQuestionResponse.bind(this);
  }

  insertSubQuestion(data){
      this.props.dispatch(insertSubQuestion(data));
  }

  componentDidMount(){
    if(this.props.location.state){
        const { editCategoryItemData } = this.props.location.state;

      if(editCategoryItemData){
          this.setState({
            editCategoryPageData : editCategoryItemData
        });
      }
    }
  }

  emptyDemoSubQuestionResponse(){
      this.props.dispatch(emptyDemoSubQuestionResponse());
  }
  
  render(){

    let showAddDemographicsCategoriesSubQuestionView = <AddSubQuestion
        insertSubQuestion = {this.insertSubQuestion}
        demoGraphicsSubQuestionAddSuccess = {this.props.demoGraphicsSubQuestionAddSuccess}
        demoGraphicsSubQuestionSuccessmessage = {this.props.demoGraphicsSubQuestionSuccessmessage}
        demoGraphicsSubQuestionFailmessage = {this.props.demoGraphicsSubQuestionFailmessage}

        emptyDemoSubQuestionResponse = {this.emptyDemoSubQuestionResponse}
    />
      
    return (
        <div> 
             {showAddDemographicsCategoriesSubQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsSubQuestionAddSuccess     : state.demographics.demoGraphicsSubQuestionAddSuccess,
    demoGraphicsSubQuestionSuccessmessage : state.demographics.demoGraphicsSubQuestionSuccessmessage,
    demoGraphicsSubQuestionFailmessage    : state.demographics.demoGraphicsSubQuestionFailmessage,    
  }
}

export default connect(mapStateToProps)(AddDemographicsSubQuestion);



// WEBPACK FOOTER //
// ./src/pages/demographics/addDemoSubQuestion.js